import React, { Component } from 'react';
//constants
import { FORM_REFS } from '../../../../constants';
//rest client
import { aemHostClient } from '../../../../restClient';
//children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';

class CanadaQuebecForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    let apiURL = "/aemData/formData/json_canada-quebec-page";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }
    aemHostClient(apiURL)
      .then(({ data }) => {
        this.setState({ formJson: data });
      });
  }

  componentDidMount() {

  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  onFormSubmit = (event, apiURL) => {

  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData;
    formData = {};
    const properties = {
      formData,
      editType: 'canada-quebec-form',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform !== undefined) {
      return (
        <Dynamicform mode={this.props.mode}
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform.formRef]}
          getFormData={this.getFormData}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel} />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.title : {};
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">{pageTitle.title}</h2>
          <p className="form-required-desc">{pageTitle.description}</p>
        </div>
        {this.renderFormGroups()}
      </div>
    );
  }
}
export default CanadaQuebecForm;



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CountryForms/CanadaQuebecForm.js